export default __webpack_public_path__ + "static/media/mkv.dfec4654.png";